import { DatasetComponentOption, LineSeriesOption, SeriesOption } from 'echarts';
import {
  RealIntervalFields,
  getIntervalDataSet,
} from '@/lowcode/common/setter/interval-setter/util';
import {
  calcGridBottom,
  getDataZoomConfig,
  getFormattedValue,
  getIntervalLabel,
  getLegendConfig,
  getMobileDataZoomConfig,
  getXFieldConfig,
  getYFieldConfig,
} from '../util';
import { defaultTheme, themeMap } from '../../types';
import { CnLineStyle } from './type';

export function getLineCharOptions(chartStyle: CnLineStyle) {
  const { xFieldConfig, yFieldConfig, legendConfig, themeColor } = chartStyle;
  const { yFieldTitle: originalYFieldTitle } = yFieldConfig || {};
  const { xFieldTitle, showScrollbar = false } = xFieldConfig || {};
  const { showLegend } = legendConfig || {};

  const yFieldTitle = getFormattedValue(originalYFieldTitle) as string;

  const offsetLeft = yFieldTitle ? 24 : 0;

  return {
    color: themeMap[themeColor || defaultTheme].color,
    ...getDataZoomConfig(showScrollbar),
    legend: getLegendConfig(showLegend, {
      left: offsetLeft,
      icon: 'path://M0,-1 L10,-1 L10,1 L0,1 Z',
    }),
    tooltip: {
      trigger: 'axis',
    },
    xAxis: getXFieldConfig(xFieldConfig),
    yAxis: getYFieldConfig(yFieldConfig),
    grid: {
      top: showLegend ? 32 : 12,
      left: offsetLeft,
      right: 12,
      bottom: calcGridBottom(xFieldTitle, showScrollbar),
      containLabel: true,
    },
    media: [
      {
        query: { maxWidth: 500 },
        option: {
          ...getMobileDataZoomConfig(showScrollbar),
          tooltip: { triggerOn: 'click' },
        },
      },
    ],
  };
}

export function getLineChartSeries(
  listData: any[],
  intervalFields: RealIntervalFields,
  chartStyle: CnLineStyle,
): {
  dataset: DatasetComponentOption;
  series: SeriesOption[];
} {
  const { dataset, series } = getIntervalDataSet(listData, intervalFields);
  const { labelConfig, toolTipConfig } = chartStyle;
  const { formatToolTipValue } = toolTipConfig || {};

  return {
    dataset,
    series: (series as LineSeriesOption[])?.map((s) => {
      return {
        ...s,
        type: 'line',
        smooth: chartStyle?.shape === 'smooth', // 平滑曲线
        areaStyle: chartStyle?.area ? { opacity: 0.1 } : undefined,
        tooltip: {
          valueFormatter: (value) => {
            return getFormattedValue(formatToolTipValue || value, value) as string;
          },
        },
        ...(getIntervalLabel(labelConfig) as LineSeriesOption),
      };
    }),
  };
}
